export const POPULAR_PRODUCTS = [
  {
    id: "blunt-prodigy-x-park",
    variants: [{ id: "blunt-prodigy-x-kuldne" }]
  },
  {
    id: "blunt-prodigy-s9",
    variants: [{ id: "blunt-prodigy-s9-oil-slick" }]
  },
  {
    id: "aztek-corsa",
    variants: [{ id: "aztek-corsa-blue" }]
  },
  {
    id: "drone-shadow-3-feather-light",
    variants: [{ id: "drone-shadow-3-feather-light-silver-anodized" }]
  },
  {
    id: "north-orbit",
    variants: [{ id: "north-orbit-matte-black" }]
  }
];